import type { TPhoneCodeOption } from "../types";

const preparePhoneOptionsList = (
  options: TPhoneCodeOption[],
  pinnedCodes: string[] = [],
  defaultCountry?: string
): TPhoneCodeOption[] => {
  const pinnedOptions = pinnedCodes.reduce<TPhoneCodeOption[]>((acc, code) => {
    const option = options.find((opt) => opt.code === code);

    // Default country will be inserted to the front, so we don't need it among the pinned codes
    if (option && option.shortName !== defaultCountry?.toUpperCase()) {
      acc.push(option);
    }

    return acc;
  }, []);

  const defaultOption = options.find((opt) => opt.shortName === defaultCountry?.toUpperCase());

  if (defaultOption) {
    pinnedOptions.unshift(defaultOption);
  }

  const otherOptions = options.filter(
    (option) => !pinnedCodes.includes(option.code) && option.shortName !== defaultOption?.shortName
  );
  return [...pinnedOptions, ...otherOptions];
};
export default preparePhoneOptionsList;
